export default {
  path: '/ip-addresses',
  component: () => import(/* webpackChunkName: "ip-addresses" */ './IpAddresses.vue'),
  meta: {
    requiresAuth: true,
    pageTitle: 'Ip Addresses'
  }
}
